'use strict';

import addTotpTemplate from './addTotp.html';
import QrCode from 'qrcode';

export default angular
  .module('main.profile.tabs.addTotp', [])

  .directive('profileAddTotpTab', () => {
    return {
      restrict: 'E',
      template: addTotpTemplate,
      scope: {},
      controller: (
        $scope,
        $q,
        $filter,
        $log,
        $interval,
        utils,
        ProfileDataProvider,
        ToastsService
      ) => {
        const $t = $filter('translate');
        $scope.dataProvider = ProfileDataProvider.instance;

        const CURRENT_SECOND_FACTOR_TYPE = 'Main-Factor';

        angular.extend($scope, {
          onConfirmTotpFactorButtonClick: onConfirmTotpFactorButtonClick,
          onCreateTotpFactorButtonClick: onCreateTotpFactorButtonClick,
          goBack: goBack,
          keyPressPasscode: keyPressPasscode,
        });

        /**
         * Create TOTP token UI state (step)
         * @type {'initial'|'qrcode'}
         */
        $scope.state = 'initial';
        $scope.secret = null;
        $scope.totpFactorName = '';
        $scope.totpFactorIssuer = '';
        $scope.passcode = '';
        $scope.confirmationTimeStr = '';

        let confirmationCountdownInterval;

        init();

        function init() {
          $scope.loading = true;
          initForm();
          initWatchers();

          $q.all([
            $scope.dataProvider.totpListResource.init(),
            $scope.dataProvider.appNameResource.init(),
          ])
            .then(() => {
              $scope.totpFactorIssuer = $scope.dataProvider.appNameResource.value;
              $scope.factors = angular.copy($scope.dataProvider.totpListResource.value || []);
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initWatchers() {
          $scope.$on('$destroy', function() {
            $.fn.form.settings.rules.duplicateTotpName = undefined;
          });
          $scope.$watch('dataProvider.totpListResource.value', (newVal, oldVal) => {
            if (newVal && newVal !== oldVal) {
              $scope.factors = angular.copy($scope.dataProvider.totpListResource.value || []);
            }
          });
        }

        function initForm() {
          $.fn.form.settings.rules.duplicateTotpName = function(value) {
            return !($scope.factors)
              .some(f => (f.name || '').toLowerCase() === (value || '').toLowerCase());
          };

          $('#form-new-totp').form({
            inline: true,
            fields: {
              name: {
                identifier: 'name',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('profile.addTotp.name-required')
                  },
                  {
                    type: 'duplicateTotpName',
                    prompt: $t('profile.addTotp.name-duplicate')
                  }
                ]
              },
              issuer: {
                identifier: 'issuer'
              },
            }
          });

          $('#form-confirm-totp').form({
            inline: true,
            fields: {
              code: {
                identifier: 'passcode',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('profile.addTotp.passcode-required')
                  },
                  {
                    type: 'regExp[/^[0-9]{6}$/gi]',
                    prompt: $t('prompt.totp.invalid')
                  }
                ]
              },
            }
          });
        }

        function onCreateTotpFactorButtonClick() {
          if ($scope.loading) {
            return;
          }
          const formEl = $('#form-new-totp');
          formEl.form('validate form');
          let isValid = formEl.form('is valid');
          if (!isValid) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.createTotpFactor($scope.totpFactorName, $scope.totpFactorIssuer)
            .then((secret) => {
              $scope.secret = secret;

              startConfirmationCountdown();
              $scope.state = 'qrcode';
              return generateQrCode(secret.url);
            })
            .then(() => {
              $scope.loading = false;
              $scope.dataProvider.totpListResource.init(true);
            }, (err) => {
              utils.handleApiError(err);
              $scope.secret = null;
              $scope.loading = false;
            });
        }

        function keyPressPasscode($event) {
          if ($event.keyCode === 13) {
            $scope.onConfirmTotpFactorButtonClick();
          }
        }

        function onConfirmTotpFactorButtonClick() {
          if ($scope.loading || !$scope.passcode || !$scope.totpFactorName) {
            return;
          }
          const formEl = $('#form-confirm-totp');
          formEl.form('validate form');
          let isValid = formEl.form('is valid');
          if (!isValid) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.confirmTotpFactor($scope.totpFactorName, $scope.passcode)
            .then(() => {
              $scope.loading = false;
              $scope.passcode = '';
              // Show success message and go back to OTP list
              ToastsService.success(null, $t('profile.addTotp.success'));
              $scope.dataProvider.totpListResource.init(true);
              // Save preffered 2FA method
              utils.setStorageItem(CURRENT_SECOND_FACTOR_TYPE, 4);
              // Redirect to TOTP list
              $scope.dataProvider.activeTab = 'totp';
            }, (err) => {
              if (err.resultCode === 8) {
                ToastsService.error($t('profile.addTotp.error'));
              } else {
                utils.handleApiError(err);
              }
              $scope.loading = false;
            });
        }

        function startConfirmationCountdown() {
          clearConfirmationCountdown();

          confirmationCountdownInterval = $interval(() => {
            const confirmationDuration = $scope.secret.maxConfirmationTimeMs - new Date().getTime();
            $scope.confirmationTimeStr = moment.duration(confirmationDuration).format();

            if (confirmationDuration < 0) {
              clearConfirmationCountdown();
              $scope.state = 'initial';
              $scope.secret = null;
              $scope.confirmationTimeStr = null;
              $scope.passcode = '';
              ToastsService.error(null, $t('profile.addTotp.otpConfirmationExpire'));
            }
          }, 1000);
        }

        function clearConfirmationCountdown() {
          if (confirmationCountdownInterval != null) {
            $interval.cancel(confirmationCountdownInterval);
            confirmationCountdownInterval = undefined;
          }
        }

        function generateQrCode(secretUrl) {
          const canvas = document.getElementById('totp-qr-code');
          if (!canvas || !secretUrl) {
            return;
          }

          // Force clear canvas
          const context = canvas.getContext('2d');
          context.clearRect(0, 0, canvas.width, canvas.height);

          return $q.when(QrCode.toCanvas(
            canvas,
            secretUrl,
            {
              errorCorrectionLevel: 'M',
              scale: 8,
              margin: 1,
              // color: {
              //   dark:"#010599FF",
              //   light:"#FFBF60FF"
              // }
            }
          ))
            .catch(err => {
              $log.error('Unable to generate QR code');
              $log.error(err);
            });
        }

        function goBack() {
          if ($scope.state === 'initial') {
            $scope.dataProvider.activeTab = 'totp';
          } else {
            $scope.state = 'initial';
            $scope.secret = null;
            $scope.confirmationTimeStr = null;
            $scope.passcode = '';
            clearConfirmationCountdown();
          }
        }

      }
    };
  })
  .name;
